import { createContext, useContext, useMemo } from "react";
import { toDashboardDefinition, type DashboardRecord } from "@/lib/dashboard/types";

export const DashboardRecordContext = createContext<DashboardRecord | null>(null);

export function useStoredDashboardDefinition() {
  const record = useContext(DashboardRecordContext);
  return useMemo(() => {
    if (!record) throw new Error("Dashboard view requires a loaded database record");
    return toDashboardDefinition(record);
  }, [record]);
}
